import { useState } from 'react';
import { dataLayerPush } from '@ertelecom/ui-react/components/helpers/index';
import { sendRequestByConnection, parseRequestByConnection } from '~/src/api/service-request/request-by-connection';
import { getClientId } from '~/src/helpers/clientInfo';
import cookie from 'react-cookies';

const dataLayerOptions = (action, label) => ({ event: 'UAevent', category: 'application_form', action, label });

export default (cityDomain, additionalOptions) => {

    const [message, setMessage] = useState(null);
    const [isLoading, setIsLoading] = useState(false);
    const [status, setStatus] = useState(null);

    const doSubmit = ({ name, phone, email }) => {

        setIsLoading(true);

        const clientId = cookie.load('_ga_cid');

        const options = {
            petition: 'create_request',
            fio: name,
            phone: phone,
            email: email,
            domain: cityDomain,
            ga_cid: clientId ? clientId : getClientId(),
            ...additionalOptions
        };

        sendRequestByConnection(cityDomain, options)
            .then(res => {
                const { message, status } = parseRequestByConnection(res);
                setStatus(status);
                setMessage(message);
                setIsLoading(false);
            })
            .catch(() => {
                setStatus('error');
                setMessage('Не удалось отправить заявку. Пожалуйста, попробуйте еще раз.');
                setIsLoading(false);

                dataLayerPush(dataLayerOptions('undefined', 'Произошла ошибка. Код не известен.'));
            });
    };

    return [{ status, isLoading, message }, doSubmit];
};
